import type { TributeItem } from 'tributejs';
import Tribute from 'tributejs';
import MarkdownIt from 'markdown-it';

// Autocompletion setup

interface UrlCompletionItem {
  name: string;
  url: string;
}

const tributeConfig = {
  trigger: '@',
  selectTemplate: (item: TributeItem<UrlCompletionItem>) => `[${item.original.name}](${item.original.url})`,
  menuItemTemplate: (item: TributeItem<UrlCompletionItem>) => item.string,
  selectClass: 'highlight',
  containerClass: 'tribute-container',
  itemClass: 'px-2 py-1',
  lookup: 'name',
  fillAttr: 'url',
  allowSpaces: false,
  autocompleteMode: false,
  searchOpts: {
    pre: '<span>',
    post: '</span>',
    skip: false,
  },
  menuShowMinLength: 1,
};

const AutoComplete = (values: UrlCompletionItem[]): Tribute<UrlCompletionItem> => new Tribute({
  values,
  ...tributeConfig,
});

// Editor functionality

const renderMarkdownContent = () => {
  document.querySelectorAll('.markdown-content').forEach((mdContainer) => {
    const markdown = mdContainer.getAttribute('data-markdown');

    if (markdown !== null) {
      mdContainer.innerHTML = new MarkdownIt().render(markdown);
      mdContainer.removeAttribute('data-markdown');
    }
  });
};

const toggleMarkdownPreview = (event: Event) => {
  const target = event.target as HTMLElement;
  const markdownContainer = target.parentNode;
  if (!markdownContainer) return;

  const preview = markdownContainer.querySelector('.markdown-preview');
  if (!preview) return;
  preview.classList.toggle('d-none');

  const editor = markdownContainer.querySelector('.markdown-editor') as HTMLInputElement;
  if (!editor) return;
  editor.classList.toggle('d-none');

  const markdown = editor.value;
  preview.innerHTML = new MarkdownIt().render(markdown);
};

const initializeEditors = () => {
  const editors = document.querySelectorAll('.markdown-editor');

  if (editors.length > 0 && window.nattwenny.autocomplete !== undefined) {
    AutoComplete(window.nattwenny.autocomplete).attach(editors[0]);
  }
};

// Library

const NwEditor = {
  initialize: (): void => {
    initializeEditors();
    renderMarkdownContent();

    document.querySelectorAll('.markdown-preview-button').forEach((previewButton) => {
      previewButton.addEventListener('click', toggleMarkdownPreview);
    });
  },
};

export default NwEditor;
